module.exports = __webpack_public_path__ + "static/media/tuya.a2b6ba0a.svg";